var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.list!==undefined)?_c('div',{staticClass:"flex flex-nowrap overflow-auto mr-2 pb-2 scrollbar-hidden"},_vm._l((_vm.list),function(tag,idx){return _c('p',{key:("tag-" + tag + "-" + idx),staticClass:"text-xs whitespace-nowrap px-2 py-0.5 border ml-2 rounded-full bg-white",class:[
      _vm.textColor,
      _vm.borderColor ]},[_vm._v(" "+_vm._s(tag)+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }